import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  UI_PORTAL_ACCOUNT_ROUTE,
  UI_PORTAL_HEADER_NOTICES,
} from '@system-dyg/shared/ui/portal-layout';
import { appRoutes } from './app.routes';
import { PORTAL_CLIENTES_HEADER_NOTICES } from './data/portal-clientes-header-notices';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes),
    { provide: UI_PORTAL_ACCOUNT_ROUTE, useValue: '/personal-data/general' },
    { provide: UI_PORTAL_HEADER_NOTICES, useValue: PORTAL_CLIENTES_HEADER_NOTICES },
  ],
};
